export const convertGraphQlToObject = (gqlObj) => {
  let obj = {
    ...gqlObj,
    translations: {},
  };
  for (let _trans of gqlObj.details) {
    obj.translations[_trans.language_code] = {
      ..._trans,
    };
  }
  delete obj.details;
  if (gqlObj.tt_hours) {
    obj.tt_hours = JSON.parse(gqlObj.tt_hours);
  }
  return obj;
};

export const convertObjetToGraphQlVariables = (obj) => {
  let gqlObj = {
    ...obj,
    details: [],
  };
  if (gqlObj.tt_hours) {
    gqlObj.tt_hours = JSON.stringify(gqlObj.tt_hours);
  }
  Object.keys(obj.translations).forEach(function (key, index) {
    if (
      obj.translations[key] &&
      obj.translations[key].hasOwnProperty('file_audio_guide')
    ) {
      if (!obj.translations[key]['file_audio_guide']) {
        obj.translations[key]['file_audio_guide'] = '';
      }
    }

    let _obj = {
      ...obj.translations[key],
      language_code: key,
    };
    delete _obj.slug;
    gqlObj.details.push(_obj);
  });
  delete gqlObj.translations;
  return gqlObj;
};



// WEBPACK FOOTER //
// ./src/helpers/contentWithI18n.js